import { useState, useEffect, useCallback } from "react";
import UnderMaintenance from "UnderMaintenance";
import { useFirebaseContext } from "context";
import { fetchAndActivate, getValue } from "firebase/remote-config";
import Loading from "components/Loading";

const APP_NAME = "SuhailBooking";

const UnderMaintenanceCheck = ({ children }) => {
  const { remoteConfig } = useFirebaseContext();
  const [firebaseData, setFirebaseData] = useState({});
  const [firebaseDataLoading, setFirebaseDataLoading] = useState({});

  const fetchRemoteConfigData = useCallback(() => {
    setFirebaseDataLoading(true);
    remoteConfig.settings = {
      // Use in-memory storage, bypassing IndexedDB
      minimumFetchIntervalMillis: 1000, // Set your desired minimum fetch interval
    };
    fetchAndActivate(remoteConfig)
      .then(() => {
        const data = JSON.parse(
          getValue(remoteConfig, "MaintenanceMode").asString()
        );
        setFirebaseData(data);
      })
      .catch((error) => {
        console.error("Error fetching Remote Config:", error);
      })
      .finally(() => {
        setFirebaseDataLoading(false);
      });
  }, []);

  useEffect(() => {
    fetchRemoteConfigData();
  }, [fetchRemoteConfigData]);

  return (
    <>
      {firebaseDataLoading ? (
        <Loading />
      ) : (
        <>
          {firebaseData?.isEnabled &&
          firebaseData?.target?.find((item) => item === APP_NAME) ? (
            <UnderMaintenance data={firebaseData} />
          ) : (
            children
          )}
        </>
      )}
    </>
  );
};

export default UnderMaintenanceCheck;
